import { useEffect, useRef } from 'react'

// Todos los propietarios comparten la primera instantánea. Ningún modal puede
// restaurar el overflow de otro ni desbloquear el fondo antes que el último.
const owners = new Map<symbol, (() => void) | undefined>()
let previous: Array<[string, string, string]> = []
const properties = ['overflow', 'overflow-x', 'overflow-y']

function handleEscape(event: KeyboardEvent) {
  if (event.key !== 'Escape' || event.defaultPrevented) return
  const close = [...owners.values()].reverse().find((callback) => callback !== undefined)
  if (!close) return
  event.preventDefault()
  event.stopPropagation()
  close()
}

export function acquireBodyScrollLock(onEscape?: () => void): () => void {
  const key = Symbol('modal')
  const body = document.body
  if (owners.size === 0) {
    previous = properties.map((property) => [property, body.style.getPropertyValue(property), body.style.getPropertyPriority(property)])
    body.style.setProperty('overflow', 'hidden')
    window.addEventListener('keydown', handleEscape)
  }
  owners.set(key, onEscape)
  return () => {
    if (!owners.delete(key) || owners.size !== 0) return
    window.removeEventListener('keydown', handleEscape)
    properties.forEach((property) => body.style.removeProperty(property))
    previous.forEach(([property, value, priority]) => {
      if (value) body.style.setProperty(property, value, priority)
    })
    previous = []
  }
}

export function useModalLifecycle(isVisible: boolean, onEscape: () => void) {
  const closeRef = useRef(onEscape)
  useEffect(() => { closeRef.current = onEscape }, [onEscape])
  useEffect(() => {
    if (!isVisible) return
    return acquireBodyScrollLock(() => closeRef.current())
  }, [isVisible])
}
